if (!customElements.get('product-form-recurate')) {
  customElements.define(
    'product-form-recurate',
    class ProductFormRecurate extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector('form')
        this.form.querySelector('[name=id]').disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer')
        this.submitButton = this.querySelector('[type="submit"]')
        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog')
        document.addEventListener('addToCartError', (e) => {
          this.errorMessageDisplay(e)
        })
      }

      onSubmitHandler(evt) {
        evt.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return

        this.handleErrorMessage()

        this.submitButton.setAttribute('aria-disabled', true)
        this.submitButton.classList.add('animate-pulse')

        const config = fetchConfig('javascript')
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        delete config.headers['Content-Type']

        const formData = new FormData(this.form)
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          )
          formData.append('sections_url', window.location.pathname)
          this.cart.setActiveElement(document.activeElement)
        }
        config.body = formData

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description)

              const soldOutMessage = this.submitButton.querySelector(
                '[data-product-form-error-message]'
              )
              if (!soldOutMessage) return
              this.submitButton.setAttribute('aria-disabled', true)
              this.submitButton.querySelector('span').classList.add('hidden')
              soldOutMessage.classList.remove('hidden')
              this.error = true
              return
            } else if (!this.cart) {
              window.location = window.routes.cart_url
              return
            }

            this.error = false
            this.cart.renderContents(response)
          })
          .catch((e) => {
            console.error(e)
          })
          .finally(() => {
            this.submitButton.classList.remove('animate-pulse')
            if (this.cart && this.cart.getAttribute('data-empty') === 'true')
              this.cart.setAttribute('data-empty', false)
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled')
            }
          })
      }

      handleErrorMessage(errorMessage = false) {
        if (errorMessage) {
          this.dispatchEvent(
            new CustomEvent('addToCartError', {
              detail: {
                errors: errorMessage,
              },
              bubbles: true,
            })
          )
        }
      }

      errorMessageDisplay(e) {
        let errorMessage =
          e.detail.errors && typeof e.detail.errors !== 'object'
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('[data-product-form-error]')
        if (!this.errorMessageWrapper) return
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '[data-product-form-error-message]'
          )

        this.errorMessageWrapper.toggleAttribute('aria-hidden', !errorMessage)
        this.errorMessage.innerText = e.detail.errors
        setTimeout(() => {
          this.errorMessageWrapper.setAttribute('aria-hidden', true)
          this.errorMessage.innerText = ''
        }, 3000)
      }
    }
  )
}
